module.exports = __webpack_public_path__ + "static/img/doctor-strange.32b0227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid/doctor-strange.jpg
// module id = 5rZO
// module chunks = 0